//  penalty status映射
export const penaltyStatusMap = [
  ['UNEXECUTED', 'Unexecuted'],
  ['EXECUTED', 'Executed'],
  ['EXEMPTED', 'Exempted']
]
//  penalty type映射
export const penaltyTypeMap = [
  ['MISSED_APPOINTMENT_CONFIRMATION', 'Missed Appointment Confirmation'],
  ['MISSED_VIDEO_CALL_FEEDBACK', 'Missed Video Call Feedback'],
  ['MISSED_ESSAY_TURNAROUND_TIME', 'Missed Essay turnaround Time'],
  ['MISSED_VIDEO_CALL_ATTENDANCE', 'Missed Video Call Attendance']
]
//  penalty module映射
export const penaltyModuleMap = [
  ['MODULE_1', 'Module 1'],
  ['MODULE_2', 'Module 2'],
  ['MODULE_3', 'Module 3'],
  ['MODULE_4', 'Module 4'],
  ['MODULE_5', 'Module 5'],
  ['MODULE_6', 'Module 6'],
  ['MODULE_7', 'Module 7'],
  ['MODULE_8', 'Module 8'],
  ['INTERVIEW', 'Interview'],
  ['MODULE_20', 'Module 20']
]
